/**
 * Командная игра бандами в кейсбатле (миграция бэкенда 408).
 *
 * Если в батле 2+ участника одной банды и победный слот достаётся одному из
 * них, банк делится между ними поровну **кристаллами** — скины не выдаются
 * никому. Поэтому в командном батле нельзя показывать ни «предметы в
 * инвентаре» победителю, ни «проиграл» тиммейту: оба получили долю.
 *
 * Все новые ключи аддитивные и могут отсутствовать (`teams`, `team_result`),
 * поэтому доступ к ним только через эти хелперы.
 */

import { buildTeamColorMap } from '../../../utils/participantColors'

/** Бэкенд отдаёт флаги и как `1`, так и как `"1"` — сравнивать только числом. */
export const isFlagOn = (value) => Number(value) === 1

/**
 * Банды батла, которые реально играют командой. `is_team: false` — в батле
 * всего один участник этой банды, он играет как одиночка и отдельной группы не
 * заслуживает (бейдж у ника ему и так рисует TeamTag).
 */
export const getBattleTeams = (battle) => (battle?.teams || []).filter((team) => team?.is_team && team?.slug)

/**
 * Подпись состава банд для useMemo: пересчитываем группировку только когда
 * изменился состав или итоги розыгрыша.
 */
export const buildBattleTeamsSignature = (teams = []) => (teams || [])
  .map((team) => [
    team?.slug || '',
    team?.is_team ? 1 : 0,
    Number(team?.count_users || 0),
    (team?.slots || []).join('.'),
    Number(team?.team_win || 0),
    Number(team?.payout || 0)
  ].join(':'))
  .sort()
  .join('|')

/**
 * Индекс банд батла: цвет по slug и банда по `user_id` игрока.
 *
 * Цвет берётся из общей палитры участников — та же банда в классике окрашена
 * так же. По `user_ids` из снапшота видно, какие слоты заняты одной бандой,
 * ещё до розыгрыша.
 */
export const buildBattleTeamIndex = (battle) => {
  const teams = getBattleTeams(battle)
  const colorBySlug = buildTeamColorMap(teams)
  const teamByUserId = new Map()

  teams.forEach((team) => {
    const userIds = team.user_ids || []
    userIds.forEach((userId) => teamByUserId.set(String(userId), team))
  })

  return { teams, colorBySlug, teamByUserId }
}

/** Итог делёжки. Ключа нет, пока банк не поделён, — это не ошибка. */
export const getTeamResult = (battle) => battle?.team_result || null

/**
 * Моя роль в командном батле. `you_team_win` приходит вместе с `you_win`, а в
 * ответе `join` последнего игрока план делёжки лежит в `result_casebattle[]`.
 */
export const getMyTeamOutcome = (battle) => {
  const players = battle?.players || []
  const mePlayer = players.find((player) => isFlagOn(player?.you))

  const teamWin = isFlagOn(battle?.you_team_win) || isFlagOn(mePlayer?.team_win)
  const payout = Number(battle?.you_team_payout || mePlayer?.team_payout || 0)

  return {
    // Показываем экран «Банда выиграла» вместо обычного выигрыша/проигрыша
    isTeamWin: teamWin,
    // Личная доля: у слота-победителя она на 1–3 кристалла больше `share`
    payout: teamWin ? payout : 0,
    // Тиммейт: его слот проиграл, но доля пришла — «проиграл» показывать нельзя
    isTeammate: teamWin && !isFlagOn(battle?.you_win) && !isFlagOn(mePlayer?.win)
  }
}
